import { Observer, observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Portal } from 'react-portal';
import classnames from 'classnames';

import { useHotkeys, useScrollLock } from 'shared/hooks';

import { UiIcon } from '../UiIcon';

import './styles.scss';

type PropsType = {
    isOpened?: boolean;
    isAside?: boolean;
    style?: React.CSSProperties;
    className?: string;
    onClose?: () => void;
    children?: React.ReactNode;
};

export const UiModal = observer(function UiModal({
    isOpened = false, isAside = false, style = {}, onClose, children, className
}: PropsType) {
    const classNames = classnames('ui-new-modal', className, {
        'ui-new-modal--aside': isAside,
        'ui-new-modal--normal': !isAside,
    });

    useScrollLock(isOpened);

    useHotkeys('escape', () => {
        if (isOpened) {
            onClose && onClose();
        }
    }, {
        enableOnFormTags: ['input', 'select', 'textarea']
    });

    if (!isOpened) {
        return null;
    }

    return (
        <Portal>
            <Observer>
                {() => (
                    <div className={classNames}>
                        <div className='ui-new-modal__overlay' onClick={onClose} />
                        <div className='ui-new-modal__body'>
                            <div className='ui-new-modal__mobile-header'>
                                <hr />
                            </div>
                            <div className='ui-new-modal__close' onClick={onClose}>
                                <UiIcon.X />
                            </div>
                            {children}
                        </div>
                    </div>
                )}
            </Observer>
        </Portal>
    );
});
